<template>
  <div class="footer">
    <el-row class="declaration">
      <el-col :sm="12" :xs="24">
        <p class="copyright">Copyright © 2021-2022 Alphatenbyte. All Rights Reserved</p>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.footer {
  background: rgba(0, 0, 0, 0.65);
  position: relative;
  z-index: 1;
  margin: 0 auto;
  .declaration {
    padding: 0 px2rem(100);
    text-align: center;
    height: px2rem(42);
    line-height: px2rem(42);
    margin: 0 auto;
    font-size: px2rem(12);
    /* identical to box height */
    background: #333;
    color: #ffffff;
    .copyright {
      text-align: left;
      margin: 0;
    }
  }
}
</style>
